const { COLORS, STATIC_COLORS, COLOR_EXTENSIONS } = require("../colors");
const { BASE } = require("./base");

const AG_THEME = {
  ...BASE,
  brand: COLOR_EXTENSIONS.ag.brand,
};

module.exports = {
  AG_THEME,
};
